import script from "./TEMA.vue?vue&type=script&lang=js"
export * from "./TEMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__